/*  */
import axios from 'axios'
import { playTestAddr, testPlayType } from './global.js'
import { rqsPre } from './global.js'
export default {
  install(Vue) {
    // let addrPre = wUrl.host + wUrl.port + wUrl.path
    // Vue.prototype.$addrPre = addrPre // 通用接口前缀
    let addrPre = rqsPre

    // testak
    Vue.prototype.$testak = (callback, error) => {
      var url = ''
      var param = { position: '' }
      axios.post(url, param, {}).then((res) => {
        if (callback) {
          callback(res.data)
        }
      }).catch(() => {
        if (error) {
          error()
        }
      })
    }

    // 下载匹配文件
    Vue.prototype.$exportMatch = () => {
      var path = `/cardMatch/exportMatch`
      var url = addrPre + path
      return url
    }

    //匹配列表
    Vue.prototype.$card_list = (page, rows, matchName, callback, error) => {
      var path = '/cardMatch/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, matchName: matchName }
      getRqs(url, param, callback, error)
    }
    // 电信卡匹配url
    Vue.prototype.$cardMatch = (networkType, dvtype, mcvl, model) => {
      var path = `/cardMatch/importMatch`
      var url = addrPre + path
      return url
    }
    //下载导入电信卡匹配模板
    Vue.prototype.$exportTemplate = () => {
      //todo 后面改回来
      var path = '/cardMatch/exportTemplate'
      var url = addrPre + path
      //  var url = 'http://172.16.36.11:8080/upload/device.xlsx';
      window.open(url, '_blank')
    }
    //寄修列表
    Vue.prototype.$Repair_list = (page, rows, customerName, contactName, contactNumber, expressTrackingNumber, callback, error) => {
      var path = '/marketRepair/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, customerName: customerName, contactName: contactName, contactNumber: contactNumber, expressTrackingNumber: expressTrackingNumber }
      getRqs(url, param, callback, error)
    }
    //重置商户密码
    Vue.prototype.$marketMerchant_retPas = (id, password, callback, error) => {
      var path = '/marketMerchant/retPassword'
      var url = addrPre + path
      var param = { id: id, password: password }
      postRqs(url, param, callback, error)
    }
    //商户启用禁用
    Vue.prototype.$marketMerchant_disable = (id, status, callback, error) => {
      var path = '/marketMerchant/disable'
      var url = addrPre + path
      var param = { id: id, status: status }
      postRqs(url, param, callback, error)
    }
    //商户列表
    Vue.prototype.$marketMerchant = (page, rows, merchantId, callback, error) => {
      var path = '/marketMerchant/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }
    //语料列表
    Vue.prototype.$marketLanguageMaterial = (page, rows, adText, callback, error) => {
      var path = '/marketLanguageMaterial/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, adText: adText }
      getRqs(url, param, callback, error)
    }
    //设备列表
    Vue.prototype.$marketDevice = (page, rows, deviceId, merchantId, callback, error) => {
      var path = '/marketDevice/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }
    //启用禁用语料
    Vue.prototype.$AdvUpdate = (id, useStatus, callback, error) => {
      var path = '/marketAds/update'
      var url = addrPre + path
      var param = { id: id, useStatus: useStatus }
      postRqs(url, param, callback, error)
    }
    //重新生成语料
    Vue.prototype.$AdvRebuild = (id, callback, error) => {
      var path = '/marketAds/rebuild'
      var url = addrPre + path
      var param = { id: id }
      getRqs(url, param, callback, error)
    }
    //广告列表
    Vue.prototype.$AdvPageList = (page, rows, startTime, endTime, merchantId, callback, error) => {
      var path = '/marketAds/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, startTime: startTime, endTime: endTime, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //广告审核处理
    Vue.prototype.$reviewReview = (id, status, refuseReason, callback, error) => {
      var path = '/marketAds/review'
      var url = addrPre + path
      var param = { id: id, status: status, refuseReason: refuseReason }
      postRqs(url, param, callback, error)
    }

    //广告审核详情
    Vue.prototype.$reviewListDetail = (id, callback, error) => {
      var path = '/marketAds/detail'
      var url = addrPre + path
      var param = { id: id }
      getRqs(url, param, callback, error)
    }

    //广告审核列表
    Vue.prototype.$reviewList = (page, rows, merchantId, callback, error) => {
      var path = '/marketAds/reviewList'
      var url = addrPre + path
      var param = { page: page, rows: rows, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    // 从产线导入设备
    Vue.prototype.$importFromPl = (orderNo, clinetKey, model, networkType, callback, error) => {
      var path = '/device/importProductDevice'
      var url = addrPre + path
      var param = { orderNo: orderNo, clinetKey: clinetKey, model: model, networkType: networkType }
      postRqs(url, param, callback, error)
    }

    // 修改用户信息
    Vue.prototype.$mdProfile = (account, nickName, phone, callback, error) => {
      var path = '/user/userInfoModify'
      var url = addrPre + path
      var param = { account: account, nickName: nickName, phone: phone }
      postRqs(url, param, callback, error)
    }

    // 修改用户密码
    Vue.prototype.$mdUsrPsw = (userId, oldPas, newPas, callback, error) => {
      var path = '/user/modifyPassword'
      var url = addrPre + path
      var param = { userId: userId, oldPas: oldPas, newPas: newPas }
      postRqs(url, param, callback, error)
    }

    // 获取验证码
    Vue.prototype.$getCode = (callback, error) => {
      var path = '/user/getCode'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 添加配置
    Vue.prototype.$addConf = (name, content, agentId, callback, error) => {
      var path = '/setting'
      var url = addrPre + path
      var param = { name: name, content: content, agentId: agentId }
      postRqs(url, param, callback, error)
    }

    // 编辑配置
    Vue.prototype.$editConf = (id, name, content, agentId, callback, error) => {
      var path = '/setting'
      var url = addrPre + path
      var param = { id: id, name: name, content: content, agentId: agentId }
      putRqs(url, param, callback, error)
    }

    // 获取配置
    Vue.prototype.$getConf = (page, rows, name, deviceId, callback, error) => {
      var path = '/setting'
      var url = addrPre + path
      var param = { name: name, page: page, rows: rows, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    // 删除配置
    Vue.prototype.$delConf = (id, callback, error) => {
      var path = `/setting/${id}`
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    // 绑定解绑配置 deviceId[] type0绑，1解
    Vue.prototype.$confBeq = (id, deviceId, type, callback, error) => {
      var path = '/setting/bindingOrUnbind'
      var url = addrPre + path
      var param = { id: id, deviceId: [deviceId], type: type }
      postRqs(url, param, callback, error)
    }

    Vue.prototype.$confUeq = (id, callback, error) => {
      var path = '/setting/bindingOrUnbind'
      var url = addrPre + path
      var param = { id: id, type: 1 }
      postRqs(url, param, callback, error)
    }

    // 查看配置 
    Vue.prototype.$confEQlist = (id, page, rows, status, lssueStatus, deviceId, callback, error) => {
      var path = '/setting/getSettingDevice'
      var url = addrPre + path
      var param = { deviceId: deviceId, id: id, page: page, rows: rows, status: status, lssueStatus: lssueStatus }
      getRqs(url, param, callback, error)
    }

    // 添加型号
    Vue.prototype.$addModel = (productKey, productName, callback, error) => {
      var path = '/product'
      var url = addrPre + path
      var param = { productKey: productKey, productName: productName }
      postRqs(url, param, callback, error)
    }

    // 编辑型号
    Vue.prototype.$editModel = (oldKey, productKey, productName, callback, error) => {
      var path = '/product/modifyinfo'
      var url = addrPre + path
      var param = { oldKey: oldKey, productKey: productKey, productName: productName }
      putRqs(url, param, callback, error)
    }

    // 删除型号
    Vue.prototype.$delModel = (productKey, callback, error) => {
      var path = '/product/' + productKey
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    // 型号管理
    Vue.prototype.$models = (page, rows, productKey, callback, error) => {
      var path = '/product'
      var url = addrPre + path
      var param = { page: page, rows: rows, productKey: productKey }
      getRqs(url, param, callback, error)
    }

    // 上下线记录
    Vue.prototype.$dvOFList = (page, rows, deviceId, status, callback, error) => {
      var path = '/device/activeInfo'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId, status: status }
      getRqs(url, param, callback, error)
    }

    //重置密码
    Vue.prototype.$resetPsw = (userId, password, token, callback, error) => {
      var path = '/user/resetPwd'
      var url = addrPre + path
      var param = { userId: userId, password: password, token: token }
      postRqs(url, param, callback, error)
    }

    //登录
    Vue.prototype.$login = (username, password, code, codeId, callback, error) => {
      var path = '/user/login'
      var url = addrPre + path
      var param = { userId: username, password: password, code: code, codeId: codeId }
      postRqs(url, param, callback, error)
    }

    //登出
    Vue.prototype.$logout = (callback, error) => {
      var path = '/user/logout'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 任务同步状态
    Vue.prototype.$taskSyncSt = (tid, callback, error) => {
      var path = `/otatask/synTaskStatus/${tid}`
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 导入任务列表
    Vue.prototype.$itask = (page, rows, callback, error) => {
      var path = '/import'
      var url = addrPre + path
      var param = { page: page, rows: rows }
      getRqs(url, param, callback, error)
    }

    // 设备助手列表
    Vue.prototype.$helperList = (page, rows, deviceId, customer, callback, error) => {
      var path = '/deviceMapping/pageList'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId, customer: customer }
      getRqs(url, param, callback, error)
    }

    // 设备助手新增
    Vue.prototype.$helperAdd = (deviceId, customer, platform, callback, error) => {
      var path = '/deviceMapping'
      var url = addrPre + path
      var param = { deviceId: deviceId, customer: customer, platform: platform }
      postRqs(url, param, callback, error)
    }

    // 设备助手删除
    Vue.prototype.$helperDel = (deviceId, mappingDeviceId, callback, error) => {
      var path = '/deviceMapping/delete'
      var url = addrPre + path
      var param = { deviceId: deviceId, mappingDeviceId: mappingDeviceId }
      delRqs(url, param, callback, error)
    }

    //设备列表
    Vue.prototype.$terList = (page, rows, deviceId, model, networkType, agentId, merchantId, agentIdSearch, status, terminalType, netSignalStart, netSignalEnd, netSignalUpdown, deviceUpdown, isLike, callback, error) => {
      var path = '/device'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId, model: model, networkType: networkType, agentId: agentId, merchantId: merchantId, agentIdSearch: agentIdSearch, status: status, terminalType: terminalType, netSignalStart: netSignalStart, netSignalEnd: netSignalEnd, netSignalUpdown: netSignalUpdown, deviceUpdown: deviceUpdown, isLike: isLike }
      getRqs(url, param, callback, error)
    }


    // 导出imei
    Vue.prototype.$outputImei = (tail) => {
      var url = addrPre + `/imei/${tail}`
      window.open(url, '_blank')
    }

    // 导出helper
    Vue.prototype.$outputImeiHelper = (tail) => {
      var url = addrPre + `/deviceMapping/exportMapping`
      window.open(url, '_blank')
    }

    // 导出任务
    Vue.prototype.$outputMisson = (id) => {
      var url = addrPre + `/otatask/reportTask/${id}`
      window.open(url, '_blank')
    }

    // 导出订单记录
    Vue.prototype.$outputRcRecord = (deviceId, order, paytype, status, merchantId, stime, etime) => {
      var token = localStorage.token ? localStorage.token : ''
      var url = addrPre + `/device/exportLogPay?deviceId=${deviceId}&order=${order}&paytype=${paytype}&status=${status}&merchantId=${merchantId}&startTime=${stime}&endTime=${etime}&token=${token}`
      window.open(url, '_blank')
    }

    // 导出分店订单记录
    Vue.prototype.$outputBCSRecord = (id, merchantId, status, stime, etime) => {
      var token = localStorage.token ? localStorage.token : ''
      var url = addrPre + `/branch/exportLogPay?id=${id}&merchantId=${merchantId}&status=${status}&startTime=${stime}&endTime=${etime}&token=${token}`
      window.open(url, '_blank')
    }

    // 导出上下线记录
    Vue.prototype.$exportOOLineRecord = (deviceId) => {
      var token = localStorage.token ? localStorage.token : ''
      var url = addrPre + `/device/activeInfExport?deviceId=${deviceId}&status=&token=${token}`
      window.open(url, '_blank')
    }

    // 导出商户
    Vue.prototype.$outputMerchant = (agentId, merchantName) => {
      var token = localStorage.token ? localStorage.token : ''
      var url = addrPre + `/merchant/exportMerchant?agentId=${agentId}&merchantName=${merchantName}&token=${token}`
      window.open(url, '_blank')
    }

    //设备详情
    Vue.prototype.$equipDetail = (page, rows, deviceId, callback, error) => {
      var path = '/device/devicedet'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    //设备测试播报
    Vue.prototype.$equipTestPlay = (cid, productKey, callback, error) => {
      //印尼本地化部署系统测试播报地址：
      //https://proxy.szzt.com.cn/indonesiaPlay?deviceId=

      const platform = testPlayType; //0: 证通生产环境，1:证通测试环境，2:印尼本地化部署
      var path = '/speaker/api/play'
      var url = 'https://pay.szzt.com.cn' + path
      var prod = playTestAddr
      var param = { id: cid, prod: prod, productKey: productKey }

      if (platform == 1) {

      } else if (platform == 2) {
        path = '/indonesiaPlay'
        url = 'https://proxy.szzt.com.cn' + path
        prod = ''
        param = { deviceId: cid }
      }
      getRqs(url, param, callback, error)
    }

    //设备对应的订单
    Vue.prototype.$equipLogpay = (page, rows, deviceId, order, paytype, status, merchantId, startTime, endTime, callback, error) => {
      var path = '/device/logpaylist'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId, order: order, paytype: paytype, status: status, merchantId: merchantId, startTime: startTime, endTime: endTime }
      getRqs(url, param, callback, error)
    }

    // 分店播报记录
    Vue.prototype.$bcstPlayRc = (page, rows, id, merchantId, status, startTime, endTime, callback, error) => {
      var path = '/branch/by'
      var url = addrPre + path
      var param = { page: page, rows: rows, id: id, merchantId: merchantId, status: status, startTime: startTime, endTime: endTime }
      getRqs(url, param, callback, error)
    }

    //删除设备
    Vue.prototype.$delEquip = (deviceId, callback, error) => {
      var path = '/device/' + deviceId
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    //ali删除设备
    Vue.prototype.$aliDelEquip = (pms, callback, error) => {
      var path = '/terminal/delete'
      var url = addrPre + path
      // var param = [{deviceId: deviceId, productKey: productKey}]
      postRqs(url, pms, callback, error)
    }

    // 删除全部设备
    Vue.prototype.$delAllEq = (agentId, deviceStatus, deviceNo, callback, error) => {
      var path = '/device/deleteDeviceAll'
      var url = addrPre + path
      var param = { agentId: agentId, deviceStatus: deviceStatus, deviceNo: deviceNo }
      postRqs(url, param, callback, error)
    }

    //添加设备
    Vue.prototype.$addEquip = (deviceid, productkey, devicename, model, clientkey, volume, devicesecret, networkType, callback, error) => {
      var path = '/device'
      var url = addrPre + path
      var param = { deviceid: deviceid, productkey: productkey, devicename: devicename, model: model, clientkey: clientkey, volume: volume, devicesecret: devicesecret, networkType: networkType }
      postRqs(url, param, callback, error)
    }
    //ali添加设备
    Vue.prototype.$aliAddEquip = (deviceid, productkey, devicename, model, clientkey, volume, devicesecret, networkType, callback, error) => {
      var path = '/terminal'
      var url = addrPre + path
      var param = { deviceid: deviceid, productkey: productkey, devicename: devicename, model: model, clientkey: clientkey, volume: volume, devicesecret: devicesecret, networkType: networkType }
      postRqs(url, param, callback, error)
    }

    //批量添加设备
    Vue.prototype.$batchAddEq = (fix, productkey, model, num, clientkey, start, end, devicesecret, networkType, callback, error) => {
      var path = '/device/backAddTerminal'
      var url = addrPre + path
      var param = { fix: fix, productkey: productkey, model: model, num: num, clientkey: clientkey, start: start, devicesecret: devicesecret, end: end, networkType: networkType }
      postRqs(url, param, callback, error)
    }

    //查找设备
    Vue.prototype.$searchEquip = (page, rows, deviceId, callback, error) => {
      var path = '/device'
      var url = addrPre + path
      var param = { page: page, rows: rows, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    //编辑设备
    Vue.prototype.$editEquip = (deviceId, devicename, model, productName, clientkey, callback, error) => {
      var path = '/device/putinfo'
      var url = addrPre + path
      var param = { deviceid: deviceId, devicename: devicename, model: model, productkey: productName, clientkey: clientkey }
      putRqs(url, param, callback, error)
    }

    // 渠道商帐号列表
    Vue.prototype.$agentChildList = (page, rows, userId, callback, error) => {
      var path = '/user'
      var url = addrPre + path
      var param = { page: page, rows: rows, userId: userId }
      getRqs(url, param, callback, error)
    }

    // 添加渠道商帐号
    Vue.prototype.$addAgentChild = (account, nickname, agentId, phone, status, roleId, callback, error) => {
      var path = '/user'
      var url = addrPre + path
      var param = { account: account, nickname: nickname, agentId: agentId, phone: phone, status: status, roleId: roleId }
      postRqs(url, param, callback, error)
    }

    // 编辑渠道商帐号
    Vue.prototype.$editAgentChild = (account, nickname, agentId, phone, status, roleId, callback, error) => {
      var path = '/user'
      var url = addrPre + path
      var param = { account: account, nickname: nickname, agentId: agentId, phone: phone, status: status, roleId: roleId }
      putRqs(url, param, callback, error)
    }

    // 删除渠道商帐号
    Vue.prototype.$delAgChild = (acid, callback, error) => {
      var path = '/user/' + acid
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    //获取添加渠道商token和id
    Vue.prototype.$getAddAgentInfo = (callback, error) => {
      var path = '/agent/generatorClientKey'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    //添加渠道商
    Vue.prototype.$addAgent = (clientKey, agentName, agentConnPeople, agentPhonenumber, parentId, callback, error) => {
      var path = '/agent'
      var url = addrPre + path
      var param = { agentName: agentName, clientKey: clientKey, agentConnPeople: agentConnPeople, agentPhonenumber: agentPhonenumber, parentId: parentId }
      postRqs(url, param, callback, error)
    }

    //编辑渠道商
    Vue.prototype.$editAgent = (agentId, clientKey, agentName, agentConnPeople, agentPhonenumber, parentId, callback, error) => {
      var path = '/agent/editAgent'
      var url = addrPre + path
      var param = { agentId: agentId, agentName: agentName, clientKey: clientKey, agentConnPeople: agentConnPeople, agentPhonenumber: agentPhonenumber, parentId: parentId }
      putRqs(url, param, callback, error)
    }

    // 渠道商列表
    Vue.prototype.$agentList = (page, rows, agentId, callback, error) => {
      var path = '/agent'
      var url = addrPre + path
      var param = { page: page, rows: rows, agentId: agentId }
      getRqs(url, param, callback, error)
    }

    // 渠道商控件列表
    Vue.prototype.$agentCtrlList = (callback, error) => {
      var path = '/agent/getAgentByParentId'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 渠道商列表, 不要页和行数
    Vue.prototype.$agentList1 = (updown, callback, error) => {
      var path = '/agent'
      var url = addrPre + path
      var param = { updown: updown }
      getRqs(url, param, callback, error)
    }

    // 渠道商移动设备
    Vue.prototype.$moveEquip = (agentId, deviceId, callback, error) => {
      var path = '/agent/move'
      var url = addrPre + path
      var param = { agentId: agentId, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    // 绑定了设备的渠道商列表,
    Vue.prototype.$agentWithDevList = (callback, error) => {
      var path = '/agent/getAgentByParentId'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 渠道商绑定设备
    Vue.prototype.$agentBindEq = (agentId, deviceId, callback, error) => {
      var path = '/agent/inBund'
      var url = addrPre + path
      var param = { agentId: agentId, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }
    // 渠道商解绑设备
    Vue.prototype.$agentUnbindEq = (agentId, deviceId, callback, error) => {
      var path = '/agent/outBund'
      var url = addrPre + path
      var param = { agentId: agentId, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    // 渠道商下的设备
    Vue.prototype.$agentEquip = (page, rows, agentId, deviceId, callback, error) => {
      var path = '/agent/devicelist'
      var url = addrPre + path
      var param = { page: page, rows: rows, agentId: agentId, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    //删除渠道商
    Vue.prototype.$delAgent = (agids, callback, error) => {
      var path = '/agent/' + agids
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    //渠道商详情
    Vue.prototype.$agentDetail = (agid, callback, error) => {
      var path = '/agent/' + agid
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    //升级列表
    Vue.prototype.$upgradeList = (page, rows, uid, deviceId, agentIdSearch, callback, error) => {
      var path = '/otatask'
      var url = addrPre + path
      var param = { name: uid, page: page, rows: rows, deviceId: deviceId, agentIdSearch: agentIdSearch }
      getRqs(url, param, callback, error)
    }

    //升级绑定所有设备
    Vue.prototype.$ugBindAll = (cid, terminalType, deviceId, agentId, flag, callback, error) => {
      var path = '/otatask/bindAll'
      var url = addrPre + path
      var param = { id: cid, terminalType: terminalType, deviceId: deviceId, agentId: agentId, flag: flag }
      getRqs(url, param, callback, error)
    }

    //升级详情绑定的设备
    Vue.prototype.$upgradeBindList = (page, rows, taskId, deviceId, status, callback, error) => {
      var path = '/otatask/getDeviceInfo'
      var url = addrPre + path
      var param = { page: page, rows: rows, taskId: taskId, deviceId: deviceId, status: status }
      getRqs(url, param, callback, error)
    }

    // 子任务列表
    Vue.prototype.$subTaskList = (page, rows, taskId, callback, error) => {
      var path = '/otatask/selectSalveTask'
      var url = addrPre + path
      var param = { page: page, rows: rows, taskId: taskId }
      getRqs(url, param, callback, error)
    }

    //升级绑定设备
    Vue.prototype.$upgradeBind = (uid, deviceId, flag, callback, error) => {
      var path = '/otatask/taskdevice'
      var url = addrPre + path
      var param = { id: uid, deviceId: deviceId, flag: flag }
      getRqs(url, param, callback, error)
    }

    //升级解绑设备
    Vue.prototype.$upgradeUnBind = (deviceId, taskId, callback, error) => {
      var path = '/otatask/outBund'
      var url = addrPre + path
      var param = { deviceId: deviceId, id: taskId }
      getRqs(url, param, callback, error)
    }

    //添加升级
    Vue.prototype.$addUpgrade = (name, info, needgprsextver, vercondition, needhwver, needusraudiover, upgradeType, otaHost, gprssysver, checkValue, agentId, networkType, isMaster, parentId, latWifiVerion, latGprsVerion, callback, error) => {
      var path = '/otatask'
      var url = addrPre + path
      var param = { name: name, info: info, needgprsextver: needgprsextver, vercondition: vercondition, needhwver: needhwver, needusraudiover: needusraudiover, upgradeType: upgradeType, otaHost: otaHost, gprssysver: gprssysver, checkValue: checkValue, agentId: agentId, networkType: networkType, isMaster: isMaster, parentId: parentId, latWifiVerion: latWifiVerion, latGprsVerion: latGprsVerion }
      postRqs(url, param, callback, error)
    }

    //编辑升级
    Vue.prototype.$editUpgrade = (uid, name, info, needgprsextver, vercondition, needhwver, needusraudiover, upgradeType, otaHost, gprssysver, checkValue, agentId, networkType, latWifiVerion, latGprsVerion, callback, error) => {
      var path = '/otatask'
      var url = addrPre + path
      var param = { id: uid, name: name, info: info, needgprsextver: needgprsextver, vercondition: vercondition, needhwver: needhwver, needusraudiover: needusraudiover, upgradeType: upgradeType, otaHost: otaHost, gprssysver: gprssysver, checkValue: checkValue, agentId: agentId, networkType: networkType, latWifiVerion: latWifiVerion, latGprsVerion: latGprsVerion }
      putRqs(url, param, callback, error)
    }

    // 删除升级
    Vue.prototype.$delUpgrade = (id, callback, error) => {
      var path = '/otatask/' + id
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    // 升级详情
    Vue.prototype.$upgradeDetail = (uid, callback, error) => {
      var path = '/otatask/details/' + uid
      var url = addrPre + path
      getRqs(url, {}, callback, error)
    }

    //开发者列表
    Vue.prototype.$devList = (page, rows, id, callback, error) => {
      var path = '/developer'
      var url = addrPre + path
      var param = { page: page, rows: rows, id: id }
      getRqs(url, param, callback, error)
    }

    //添加开发者
    Vue.prototype.$addDeveloper = (accessid, productKey, accessKey, name, phone, email, address, enable, clientKey, aliProductKey, callback, error) => {
      var path = '/developer'
      var url = addrPre + path
      var param = { accessid: accessid, productKey: productKey, accessKey: accessKey, name: name, phone: phone, email: email, address: address, enable: enable, clientKey: clientKey, aliProductKey: aliProductKey }
      postRqs(url, param, callback, error)
    }

    //编辑开发者
    Vue.prototype.$editDeveloper = (dvpid, productKey, accessid, accessKey, name, phone, email, address, enable, clientKey, aliProductKey, callback, error) => {
      var path = '/developer/' + dvpid
      var url = addrPre + path
      var param = { productKey: productKey, accessid: accessid, accessKey: accessKey, name: name, phone: phone, email: email, address: address, enable: enable, clientKey: clientKey, aliProductKey: aliProductKey }
      putRqs(url, param, callback, error)
    }

    // 删除开发者
    Vue.prototype.$delDevlp = (id, callback, error) => {
      var path = '/developer/' + id
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    // 查询首页统计数据
    Vue.prototype.$queryIndexTotalSumData = (callback, error) => {
      var path = '/homepage'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }


    // 支音-渠道商列表
    Vue.prototype.$squeakyAgentList = (param, callback, error) => {
      var path = '/squeakyAgent/pageList'
      var url = addrPre + path
      getRqs(url, param, callback, error)
    }


    // 支音-增加渠道商
    Vue.prototype.$addsqueakyAgent = (data, callback, error) => {
      var path = '/squeakyAgent'
      var url = addrPre + path
      postRqs(url, data, callback, error)
    }

    // 支音-编辑渠道商
    Vue.prototype.$editsqueakyAgent = (data, callback, error) => {
      var path = '/squeakyAgent'
      var url = addrPre + path
      putRqs(url, data, callback, error)
    }


    // 支音-删除渠道商
    Vue.prototype.$delqueakyAgent = (id, callback, error) => {
      var path = '/squeakyAgent/' + id
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }


    // 支音-设备列表
    Vue.prototype.$squeakyDeviceList = (param, callback, error) => {
      var path = '/squeakyPlan/pageList'
      var url = addrPre + path
      getRqs(url, param, callback, error)
    }

    // 支音-设备渠道商控件列表
    Vue.prototype.$agentsqueakyCtrlList = (callback, error) => {
      var path = '/squeakyAgent/list'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 支音-解绑设备
    Vue.prototype.$agentsqueakyUnbind = (param, callback, error) => {
      var path = '/squeakyPlan/unBind'
      var url = addrPre + path
      getRqs(url, param, callback, error)
    }

    // 支音-播报记录列表
    Vue.prototype.$agentlogpaylist = (param, callback, error) => {
      var path = '/squeakyPlan/logpaylist'
      var url = addrPre + path
      var param = param
      getRqs(url, param, callback, error)
    }




    // 查询首页统计数据
    Vue.prototype.$homestEq = (startTime, endTime, type, callback, error) => {
      var path = '/homepage/devicebar'
      var url = addrPre + path
      var param = { startTime: startTime, endTime: endTime, type: type }
      getRqs(url, param, callback, error)
    }
    // 查询首页统计数据
    Vue.prototype.$homestPl = (startTime, endTime, type, callback, error) => {
      var path = '/homepage/broadcastbar'
      var url = addrPre + path
      var param = { startTime: startTime, endTime: endTime, type: type }
      getRqs(url, param, callback, error)
    }

    //获取分店列表
    Vue.prototype.$bcstoreList = (page, rows, merchantId, branchName, callback, error) => {
      var path = '/branch'
      var url = addrPre + path
      var param = { page: page, rows: rows, branchName: branchName, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    // 根据mcid获取分店列表
    Vue.prototype.$bcstoreListByMcid = (merchantId, callback, error) => {
      var path = '/branch/getBranchList'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //添加分店
    Vue.prototype.$addBcstore = (branchName, branchNo, merchantId, callback, error) => {
      var path = '/branch'
      var url = addrPre + path
      var param = { branchName: branchName, branchNo: branchNo, merchantId: merchantId }
      postRqs(url, param, callback, error)
    }

    //编辑分店
    Vue.prototype.$editBcstore = (id, branchName, branchNo, merchantId, callback, error) => {
      var path = '/branch'
      var url = addrPre + path
      var param = { id: parseInt(id), branchName: branchName, branchNo: branchNo, merchantId: merchantId }
      putRqs(url, param, callback, error)
    }

    // 分店详情
    Vue.prototype.$bcstoreDetail = (id, callback, error) => {
      var path = '/branch/details'
      var url = addrPre + path
      var param = { id: id }
      getRqs(url, param, callback, error)
    }

    // 分店详情绑定设备
    Vue.prototype.$bcstoreDetailEQList = (id, callback, error) => {
      var path = '/branch/device'
      var url = addrPre + path
      var param = { id: id }
      getRqs(url, param, callback, error)
    }

    // 分店绑定设备 
    Vue.prototype.$bcstoreBindEq = (merchantNo, id, deviceId, callback, error) => {
      var path = '/branch/bd'
      var url = addrPre + path
      var param = { id: id, deviceId: deviceId, merchantNo: merchantNo }
      getRqs(url, param, callback, error)
    }

    // 编辑绑定设备
    Vue.prototype.$editBindEq = (id, deviceId, merchantId, callback, error) => {
      var path = '/branch/bdmodify'
      var url = addrPre + path
      var param = { id: id, deviceId: deviceId, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    // 分店解绑设备
    Vue.prototype.$bcstoreUnbindEq = (merchantId, id, deviceId, callback, error) => {
      var path = '/branch/branchOutdevice'
      var url = addrPre + path
      var param = { id: id, deviceId: deviceId, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    // 删除分店
    Vue.prototype.$delBcstore = (id, callback, error) => {
      var path = '/branch'
      var url = addrPre + path
      var param = { id: id }
      delRqs(url, param, callback, error)
    }

    //商户获取商户号
    Vue.prototype.$mcGetmcno = (merchantId, callback, error) => {
      var path = '/branch/merchantName'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }


    //添加商户
    Vue.prototype.$addMerch = (merchantName, merchantPhone, agentId, contacts, merchantNo, subMerchant, channelNo, callback, error) => {
      var path = '/merchant'
      var url = addrPre + path
      var param = { merchantName: merchantName, merchantPhone: merchantPhone, agentId: agentId, contacts: contacts, merchantNo: merchantNo, subMerchant: subMerchant, channelNo: channelNo }
      postRqs(url, param, callback, error)
    }

    //商户详情
    Vue.prototype.$merchDetail = (merchantId, callback, error) => {
      var path = '/merchant/' + merchantId
      var url = addrPre + path
      getRqs(url, null, callback, error)
    }

    //编辑商户
    Vue.prototype.$editMerchant = (merchantId, merchantName, merchantPhone, contacts, agentId, merchantNo, subMerchant, channelNo, callback, error) => {
      var path = '/merchant'
      var url = addrPre + path
      var param = { merchantId: merchantId, merchantName: merchantName, merchantPhone: merchantPhone, contacts: contacts, agentId: agentId, merchantNo: merchantNo, subMerchant: subMerchant, channelNo: channelNo }
      putRqs(url, param, callback, error)
    }

    //获取商户列表
    Vue.prototype.$merchList = (page, rows, merchantId, agentId, merchantName, callback, error) => {
      var path = '/merchant'
      var url = addrPre + path
      var param = { page: page, rows: rows, merchantId: merchantId, agentId: agentId, merchantName: merchantName }
      getRqs(url, param, callback, error)
    }

    // 商户查设备
    Vue.prototype.$mechGetEq = (merchantId, sn, callback, error) => {
      var path = '/branch/getDevice'
      var url = addrPre + path
      var param = { merchantId: merchantId, sn: sn }
      getRqs(url, param, callback, error)
    }

    // 商户绑定设备列表
    Vue.prototype.$merchBindEqList = (page, rows, merchantId, callback, error) => {
      var path = '/merchant/listdevice'
      var url = addrPre + path
      var param = { page: page, rows: rows, merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //删除设备
    Vue.prototype.$delMerch = (merchId, callback, error) => {
      var path = '/merchant/' + merchId
      var url = addrPre + path
      var param = {}
      delRqs(url, param, callback, error)
    }

    //绑定商户
    Vue.prototype.$bindMerch = (merchantId, deviceId, callback, error) => {
      var path = '/merchant/bd'
      var url = addrPre + path
      var param = { merchantId: merchantId, deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    //解绑商户
    Vue.prototype.$unbindMerch = (deviceId, callback, error) => {
      var path = '/device/outbd'
      var url = addrPre + path
      var param = { deviceId: deviceId }
      getRqs(url, param, callback, error)
    }

    //下载设备模板
    Vue.prototype.$getEqTempFile = () => {
      //todo 后面改回来
      var path = '/deviceTemplate'
      var url = addrPre + path
      //  var url = 'http://172.16.36.11:8080/upload/device.xlsx';
      window.open(url, '_blank')
    }

    //下载导入设备模板
    Vue.prototype.$getDownFile = () => {
      //todo 后面改回来
      var path = '/smidTemplate'
      var url = addrPre + path
      //  var url = 'http://172.16.36.11:8080/upload/device.xlsx';
      window.open(url, '_blank')
    }

    //下载导入之音设备模板
    Vue.prototype.$squeexportTemplate = ({ }, callback, error) => {
      var path = `/squeakyPlan/exportTemplate`
      var url = addrPre + path
      var data = {}
      ImpRqess(url, data, callback, error)
    }


    //下载导出imei模板
    Vue.prototype.$getEpIMEITmp = () => {
      var path = '/imsiTemplate'
      var url = addrPre + path
      window.open(url, '_blank')
    }

    /// 导出配置
    Vue.prototype.$outputSetting = (id, status, lssueStatus) => {
      var path = `/setting/reportSetting/${id}?status=${status}&lssueStatus=${lssueStatus}`
      var url = addrPre + path
      window.open(url, '_blank')
    }

    //下载商户模板
    Vue.prototype.$getMcTempFile = () => {
      var path = '/agentDeviceTemplate'
      var url = addrPre + path
      // var url = 'http://172.16.36.11:8080/upload/agentDevice.xlsx';
      window.open(url, '_blank')
    }

    //下载商户详情设备模板
    Vue.prototype.$getMcDtEqFile = () => {
      var path = '/merchantBindDeviceTemplate'
      var url = addrPre + path
      // var url = 'http://172.16.36.11:8080/upload/agentDevice.xlsx';
      window.open(url, '_blank')
    }

    //下载升级详情模板
    Vue.prototype.$getUpgDtTempFile = () => {
      var path = '/taskTemplate'
      var url = addrPre + path
      // var url = 'http://172.16.36.11:8080/upload/agentDevice.xlsx';
      window.open(url, '_blank')
    }

    //下载设备迁移模板
    Vue.prototype.$getEQMoveTemp = () => {
      var path = '/transferDeviceTemplate'
      var url = addrPre + path
      window.open(url, '_blank')
    }

    //下载商户ADMIN模板
    Vue.prototype.$getMcImportTempFile = (type) => {
      //// 0 admin 1 agent
      var path = type == 0 ? '/merchantAdminImport' : '/merchantImport'
      var url = addrPre + path
      window.open(url, '_blank')
    }

    //下载参数管理模板
    Vue.prototype.$getPmTempFile = () => {
      var path = '/settingImport'
      var url = addrPre + path
      window.open(url, '_blank')
    }

    //下载三元组模板
    Vue.prototype.$getTaTempFile = () => {
      var path = '/updateDeviceTriadTemplate'
      var url = addrPre + path
      window.open(url, '_blank')
    }

    // 设备imei导入url
    Vue.prototype.$imeiUrl = () => {
      var path = `/device/exportImei`
      var url = addrPre + path
      return url
    }

    // helper设备imei导入url
    Vue.prototype.$helperUrl = () => {
      var path = `/deviceMapping/exportMapping`
      var url = addrPre + path
      return url
    }

    // 设备导入url
    Vue.prototype.$eqExUlAction = (networkType, dvtype, mcvl, model) => {
      var path = `/device/uploadmore?networkType=${networkType}&clientKey=${mcvl}&productKey=${dvtype}&model=${model}`
      var url = addrPre + path
      return url
    }

    // 设备导入url
    Vue.prototype.$eqImpAction = (networkType, dvtype, mcvl, model) => {
      var path = `/device/deviceSmidImport`
      var url = addrPre + path
      return url
    }

    // 支音设备导入url
    Vue.prototype.$squeImpAction = () => {
      var path = `/squeakyPlan/importPlan`
      var url = addrPre + path
      return url
    }

    // ali设备导入url
    Vue.prototype.$aliEqExUlAction = (networkType, dvtype, mcvl, model) => {
      // var path = `/terminal/uploadmore?hwver=${hwver}`
      var path = `/terminal/uploadmore?networkType=${networkType}&clientKey=${mcvl}&productKey=${dvtype}&model=${model}`
      var url = addrPre + path
      return url
    }

    // 添加任务导入文件
    Vue.prototype.$msImportUrl = () => {
      // var path = `/file/upload`
      var token = localStorage.token ? localStorage.token : ''
      var path = `/szzt/file/uploadfile?token=${token}`
      var url = addrPre + path
      return url
    }

    // 商户导入url
    Vue.prototype.$mcExUlAction = (agid) => {
      var path = '/agent/uploadmore?agentId=' + agid
      var url = addrPre + path
      return url
    }

    // 商户ali导入url
    Vue.prototype.$mcAliExUlAction = (agid) => {
      var path = '/agent/uploadMoreToAli?agentId=' + agid
      var url = addrPre + path
      return url
    }

    // 参数导入url
    Vue.prototype.$pmipAction = (pid) => {
      var path = '/setting/importSetting?id=' + pid
      var url = addrPre + path
      return url
    }

    // 三元组导入url
    Vue.prototype.$taipAction = () => {
      var path = '/device/updateDeviceTriad'
      var url = addrPre + path
      return url
    }

    // 商户详情设备导入url
    Vue.prototype.$mcdteqExUlAction = (agid) => {
      var path = '/merchant/batchBinding'
      var url = addrPre + path
      return url
    }

    // 商户导入商户url
    Vue.prototype.$mcimportAction = (type, agid) => {
      //// 0 admin 1 agent	  
      var param = type == 0 ? 'flag=true' : `agentId=${agid}`
      var path = '/merchant/batchImportMerchant?' + param
      var url = addrPre + path
      return url
    }

    // 设备迁移导入url
    Vue.prototype.$eqMoveAction = (current, target) => {
      var path = '/device/transferDevice?' + `current=${current}&target=${target}`
      var url = addrPre + path
      return url
    }

    // 设备助手导入url
    Vue.prototype.$eqhelperAction = (consumer, platform) => {
      var path = `/deviceMapping/importMapping?consumer=${consumer}&platform=${platform}`
      var url = addrPre + path
      return url
    }

    // 升级详情导入url
    Vue.prototype.$upgDtExUlAction = (tid, networkType) => {
      var path = '/otatask/batchImport?taskId=' + tid + '&flag=true' + '&networkType=' + networkType
      var url = addrPre + path
      return url
    }

    // //上传设备文件
    // Vue.prototype.$updataDevFile = (callback, error) => {
    //   var path = '/equipment/uploadmore'
    //   var url = addrPre + path
    //   var param = {userId: userId, nickName: nickName, phone: phone, roleId:roleId, agentId: agentId,tranParams:tranParams}
    //   postRqs(url, param, callback, error)
    // }

    //

    function timeout() {
      localStorage.token = ''
      Vue.prototype.$clearTmp()
      location.hash = "#/login"
    }

    // json post
    var postRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : param.token
      var language = localStorage.lang_jp == 'zh_cn' ? "zh-CN" : 'en-US';
      if (localStorage.lang_jp == 'vi') {
        language = "vi-rVN"
      }
      if (!token) timeout()
      // param.language = localStorage.system_lang
      // param.token = token
      // axios.defaults.withCredentials = true
      axios.post(url, param, { headers: { token: token, "Accept-Language": language } }).then((res) => {
        if (res.data.status == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).catch(() => {
        if (error) {
          error()
        }
      })
    }
    var getRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      var language = localStorage.lang_jp == 'zh_cn' ? "zh-CN" : 'en-US';
      if (localStorage.lang_jp == 'vi') {
        language = "vi-rVN"
      }
      if (!token) timeout()
      // param.token = token
      // axios.defaults.withCredentials = true
      axios.get(url, { headers: { token: token, "Accept-Language": language }, params: param }).then(res => {
        if (res.data.status == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
    var delRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      var language = localStorage.lang_jp == 'zh_cn' ? "zh-CN" : 'en-US';
      if (localStorage.lang_jp == 'vi') {
        language = "vi-rVN"
      }
      if (!token) timeout()
      // param.token = token
      // axios.defaults.withCredentials = true
      axios.delete(url, { headers: { token: token, "Accept-Language": language }, params: param }).then(res => {
        if (res.data.code == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
    var putRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      var language = localStorage.lang_jp == 'zh_cn' ? "zh-CN" : 'en-US';
      if (!token) timeout()
      // param.token = token
      // axios.defaults.withCredentials = true
      axios.put(url, param, { headers: { token: token, "Accept-Language": language } }).then(res => {
        if (res.data.status == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }

    var ImpRqess = function (url, data, callback, error) {
      // var responseType = 'blob'
      // data.language = localStorage.tms_prod_systemLang ? localStorage.tms_prod_systemLang : 'zh_cn'
      // data.token = localStorage.tms_prod_token ? localStorage.tms_prod_token : ''
      // Vue.http.post(url,data,{responseType:'blob'}).then((res) => {
      // 	console.log(res)
      // 	var code = res.body.status
      // 	if (code === 600) {
      // 		location.hash = "#/login"
      // 	}
      // 	if (callback) {
      // 		callback(res.body)
      // 	}
      // }).catch((res1) => {
      // 	if (error) {
      // 		error(res1)
      // 	}
      // })

      var token = localStorage.token ? localStorage.token : param.token
      var language = localStorage.lang_jp == 'zh_cn' ? "zh-CN" : 'en-US';
      if (localStorage.lang_jp == 'vi') {
        language = "vi-rVN"
      }
      if (!token) timeout()
      axios.post(url, data, { responseType: 'blob' }).then((res) => {
        console.log(res)
        if (res.data.status == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).catch(() => {
        if (error) {
          error()
        }
      })
    }
  }
}
